import SiteHeroPage from './SiteHeroPage';

export default SiteHeroPage;
